import service from './request';
import { cachedRequest, paramsKey } from './cache';

export function getCaseCategories() {
  return cachedRequest('cases/categories', () => service.get('/api/front/cases/categories'));
}
export function getCases(params?: any) {
  return cachedRequest('cases?' + paramsKey(params), () => service.get('/api/front/cases', { params }));
}
export function getCaseById(id: number) {
  return cachedRequest('case/' + id, () => service.get('/api/front/cases/' + id));
}
